import type { IReorderMenuItem } from './types';

export const reorderMenuItem = async ({
  accessToken,
  itemId,
  newDisplayOrder,
}: IReorderMenuItem): Promise<Response> => {
  const api = process.env.REACT_APP_API_ENDPOINT;
  const uri = `${api}/items/${itemId}/reorder`;
  return fetch(uri, {
    method: 'PATCH',
    body: JSON.stringify({ display_order: newDisplayOrder }),
    cache: 'reload',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });
};
